import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import {
  bookingContainersRoute,
  bookingCustomsRoute,
  bookingDetailsRoute,
  bookingDocumentsRoute,
  bookingPriceBreakdownRoute,
  bookingRootRoute,
} from '../features/overview/routes'

const bookingsCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/create',
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('../features/wizard/routes/BookingCreateWizardRoot').then((d) => d.Route))

const manualQuoteBookRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/quotes/$quoteId/book',
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('../features/mq-select/routes/ManualQuoteBookRoot').then((d) => d.Route))

export const bookingsRoutes = [
  bookingsCreateRoute,
  manualQuoteBookRoute,
  bookingRootRoute.addChildren([
    bookingDetailsRoute,
    bookingContainersRoute,
    bookingPriceBreakdownRoute,
    bookingCustomsRoute,
    bookingDocumentsRoute,
  ]),
]
